import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { Cmg1003DeclarationsState, Cmg1003DeclarationsStore } from './declarations.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class Cmg1003DeclarationsQuery extends QueryEntity<Cmg1003DeclarationsState> {
  protected store: Cmg1003DeclarationsStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(Cmg1003DeclarationsStore);

    super(store);

    this.store = store;
  }

  getValueByBorrowerIds(borrowerIds: number[]) {
    return this.getAll({
      filterBy: (t) => borrowerIds.some((b) => t.borrowerId === b),
    });
  }
}
